import React, { useEffect, useState } from "react";
import { Lightning, SpeakerHigh } from "@phosphor-icons/react";
import { usePlayer } from "../context/PlayerContext";

// Shown after 5s on the public landing if browser blocked autoplay-with-sound
// AND the visitor hasn't interacted yet. One tap unmutes + ensures playback.
export default function StartShoowSplash() {
  const { isMuted, currentTrack, toggleMute, play, isPlaying } = usePlayer();
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (dismissed) return;
    const t = setTimeout(() => {
      if (isMuted) setShow(true);
    }, 5000);
    return () => clearTimeout(t);
  }, [isMuted, dismissed]);

  // Any meaningful user interaction implies they're engaged — don't nag.
  useEffect(() => {
    if (!isMuted && show) setShow(false);
  }, [isMuted, show]);

  if (!show || dismissed || !currentTrack) return null;

  const start = () => {
    if (isMuted) toggleMute();
    if (!isPlaying) play();
    setDismissed(true);
    setShow(false);
  };

  return (
    <div
      className="fixed inset-0 z-[80] bg-ink-900/85 backdrop-blur-xl flex items-center justify-center px-6"
      data-testid="start-splash"
      onClick={start}
    >
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); start(); }}
        className="group relative flex flex-col items-center gap-6 text-center max-w-md cursor-pointer"
        data-testid="start-splash-button"
      >
        <div className="relative">
          <div className="absolute inset-0 rounded-full bg-neon-cyan/30 blur-3xl animate-pulse-glow" />
          <div className="relative w-28 h-28 rounded-full bg-neon-cyan text-black flex items-center justify-center shadow-[0_0_60px_rgba(255,138,60,0.6)] group-hover:scale-105 transition-transform duration-300">
            <SpeakerHigh size={44} weight="fill" />
          </div>
        </div>
        <div>
          <p className="text-[11px] font-bold tracking-[0.4em] text-neon-cyan uppercase mb-2 inline-flex items-center gap-2">
            <Lightning size={12} weight="fill" /> Undaground Shoow
          </p>
          <h2 className="text-4xl sm:text-5xl font-black tracking-tighter text-white mb-2">
            Tap to Start the Shoow.
          </h2>
          <p className="text-sm text-zinc-400 max-w-sm mx-auto">
            Your browser blocked us from playing audio with sound. One tap unlocks the countdown — full volume, autoplay through all ten.
          </p>
        </div>
        <span className="text-[10px] font-mono tracking-widest text-zinc-500 uppercase">
          Now cued: #{String(currentTrack.rank).padStart(2, "0")} · {currentTrack.song_title}
        </span>
      </button>
    </div>
  );
}
